import _inject from "@stylexjs/stylex/lib/stylex-inject";
import * as stylex from "@stylexjs/stylex";
_inject(".ev1m4sxrb{box-shadow:0 0 0 3px light-dark(rgba(104,152,255,.25),rgba(215,255,114,.44))}", 3000);
_inject(".ev1jqyx15{transition:box-shadow .1s}", 2000);
_inject(".ev83z2og{background-color:#fff}", 3000);
_inject(".ev1xlr1w8{font-weight:700}", 3000);
_inject(".ev1k4tb9n{font-style:italic}", 3000);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".evwnonoy{background-color:var(--accent)}", 3000);
_inject(".ev1t82s79:hover{background-color:var(--accent-light)}", 3130);
_inject(".ev8zs5fl:active{background-color:var(--accent-dark)}", 3170);
_inject(".ev5lolih:disabled{background-color:var(--shade-05)}", 3092);
_inject("@media (hover: hover){.evxcoi9g.evxcoi9g:disabled{background-color:var(--shade-05)}}", 3292);
_inject(".ev1ghz6dp{margin:0}", 1000);
_inject(".evr0sq7q{color:var(--shade-80)}", 3000);
_inject(".ev1y1nk60:disabled{color:var(--shade-15)}", 3092);
_inject(".ev1h2kqdt{transition:background-color .2s}", 2000);
_inject(".ev1ypdohk{cursor:pointer}", 3000);
_inject(".ev1s07b3s:disabled{cursor:not-allowed}", 3092);
_inject(".evdfu9ks{padding:10px 20px}", 1000);
_inject(".evc342km{border-width:0}", 2000);
_inject(".ev1j61zf2{font-size:16px}", 3000);
_inject(".ev1sere54{padding:5px 15px 5px 15px}", 1000);
_inject(".ev1d1pktc{box-shadow:0}", 3000);
_inject(".evjbqb8w{background-color:transparent}", 3000);
_inject(".evotx0s4:hover{background-color:var(--shade-light)}", 3130);
_inject(".evvrr5wz:disabled{background-color:var(--shade-dark)}", 3092);
_inject(".ev15elmyd{border:1px solid var(--shade-light)}", 1000);
_inject(".evbdhxtj:disabled{border:1px solid var(--shade-dark)}", 1092);
_inject(".ev1bdpvq3{color:var(--text-on-shade-secondary)}", 3000);
_inject(".ev1jo8pe8{color:var(--shade-30)}", 3000);
_inject(".evtvhhri{text-transform:uppercase}", 3000);
_inject(".evgommxb{font-size:.8rem}", 3000);
_inject(".ev4z9k3i{font-size:13px}", 3000);
_inject(".ev17e5z5g{color:var(--text-color)}", 3000);
_inject(".evorixrz{border-radius:100%}", 2000);
_inject(".ev5gkzjs{transition:background-color .2s ease}", 2000);
_inject(".ev3dtjww:hover{background-color:var(--shade-10)}", 3130);
_inject(".ev1ko5yus:active{background-color:var(--shade-20)}", 3170);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev6s0dn4{align-items:center}", 3000);
_inject(".evl56j7k{justify-content:center}", 3000);
_inject(".ev1lcnupm{color:var(--shade-10)}", 3000);
_inject(".evlyipyv{text-overflow:ellipsis}", 3000);
_inject(".evuxw1ft{white-space:nowrap}", 3000);
_inject(".evb3r6kr{overflow:hidden}", 2000);
_inject(".eveuugli{min-width:0}", 4000);
_inject(".ev1l7klhg{flex-basis:100%}", 3000);
_inject("@media(min-width:501px){.ev141qb35.ev141qb35{display:none}}", 3200);
_inject("@media(max-width:500px){.ev1afdwag.ev1afdwag{display:none}}", 3200);
_inject("@media(max-width:500px){.ev1imrgc4.ev1imrgc4{padding:20px}}", 1200);
_inject("@media(min-width:501px){.ev1o4hojl.ev1o4hojl{display:block}}", 3200);
export var styling = {
  focusRing: {
    "styles__styling.focusRing": "styles__styling.focusRing",
    boxShadow: "ev1m4sxrb",
    transition: "ev1jqyx15",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    $$css: true
  },
  background: {
    "styles__styling.background": "styles__styling.background",
    backgroundColor: "ev83z2og",
    $$css: true
  },
  text_bold: {
    "styles__styling.text_bold": "styles__styling.text_bold",
    fontWeight: "ev1xlr1w8",
    $$css: true
  },
  text_italics: {
    "styles__styling.text_italics": "styles__styling.text_italics",
    fontStyle: "ev1k4tb9n",
    $$css: true
  },
  withRadius: {
    "styles__styling.withRadius": "styles__styling.withRadius",
    borderRadius: "evxwrc4x",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    $$css: true
  },
  button: {
    "styles__styling.button": "styles__styling.button",
    backgroundColor: "evwnonoy ev1t82s79 ev8zs5fl ev5lolih evxcoi9g",
    margin: "ev1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    color: "evr0sq7q ev1y1nk60",
    transition: "ev1h2kqdt",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    cursor: "ev1ypdohk ev1s07b3s",
    padding: "evdfu9ks",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderWidth: "evc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderRadius: "evxwrc4x",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    fontSize: "ev1j61zf2",
    $$css: true
  },
  smallButton: {
    "styles__styling.smallButton": "styles__styling.smallButton",
    padding: "ev1sere54",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  buttonSecondary: {
    "styles__styling.buttonSecondary": "styles__styling.buttonSecondary",
    boxShadow: "ev1d1pktc",
    backgroundColor: "evjbqb8w evotx0s4 evvrr5wz",
    border: "ev15elmyd evbdhxtj",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    color: "ev1bdpvq3",
    $$css: true
  },
  noMargin: {
    "styles__styling.noMargin": "styles__styling.noMargin",
    margin: "ev1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  meta: {
    "styles__styling.meta": "styles__styling.meta",
    color: "ev1jo8pe8",
    textTransform: "evtvhhri",
    fontSize: "evgommxb",
    $$css: true
  },
  searchFilterLabel: {
    "styles__styling.searchFilterLabel": "styles__styling.searchFilterLabel",
    fontSize: "ev4z9k3i",
    color: "ev17e5z5g",
    $$css: true
  },
  roundedButton: {
    "styles__styling.roundedButton": "styles__styling.roundedButton",
    borderRadius: "evorixrz",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    transition: "ev5gkzjs",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    backgroundColor: "evjbqb8w ev3dtjww ev1ko5yus",
    display: "ev78zum5",
    alignItems: "ev6s0dn4",
    justifyContent: "evl56j7k",
    $$css: true
  },
  muted_text: {
    "styles__styling.muted_text": "styles__styling.muted_text",
    color: "ev1lcnupm",
    $$css: true
  },
  with_ellipsis: {
    "styles__styling.with_ellipsis": "styles__styling.with_ellipsis",
    textOverflow: "evlyipyv",
    whiteSpace: "evuxw1ft",
    overflow: "evb3r6kr",
    overflowX: null,
    overflowY: null,
    minWidth: "eveuugli",
    flexBasis: "ev1l7klhg",
    $$css: true
  },
  mobile_only: {
    "styles__styling.mobile_only": "styles__styling.mobile_only",
    "@media(min-width:501px)_display": "ev141qb35",
    $$css: true
  },
  wide_only: {
    "styles__styling.wide_only": "styles__styling.wide_only",
    "@media(max-width:500px)_display": "ev1afdwag",
    $$css: true
  },
  center_center: {
    "styles__styling.center_center": "styles__styling.center_center",
    display: "ev78zum5",
    alignItems: "ev6s0dn4",
    justifyContent: "evl56j7k",
    $$css: true
  },
  mobile_pad_20: {
    "styles__styling.mobile_pad_20": "styles__styling.mobile_pad_20",
    "@media(max-width:500px)_padding": "ev1imrgc4",
    "@media(max-width:500px)_paddingInline": null,
    "@media(max-width:500px)_paddingStart": null,
    "@media(max-width:500px)_paddingLeft": null,
    "@media(max-width:500px)_paddingEnd": null,
    "@media(max-width:500px)_paddingRight": null,
    "@media(max-width:500px)_paddingBlock": null,
    "@media(max-width:500px)_paddingTop": null,
    "@media(max-width:500px)_paddingBottom": null,
    $$css: true
  },
  web_only: {
    "styles__styling.web_only": "styles__styling.web_only",
    "@media(min-width:501px)_display": "ev1o4hojl",
    "@media(max-width:500px)_display": "ev1afdwag",
    $$css: true
  }
};